
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },

    name: {
      type: String,
      default: null,
    },
  },
};
